import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SumsubWebSdk from "@sumsub/websdk-react";
import ContinueOnDevice from "../../utilities/element/ContinueOnDevice";
import USCitizenBlock from "./USCitizenBlock";

import { sumsubThunks } from "../../../actions-thunks/sumsub-thunk";
import { SumSubAPI } from "../../../api/sumsub-api";
import { utilityFns } from "../../utilities/utility-functions";

import "./sumsub.scss";

const SumSubInstance = ({ setLocalState, stepsData }) => {
  const { accessToken } = useSelector((state) => state.sumsub);
  const {
    profile,
  } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const [usCitizenBlocked, setUsCitizenBlocked] = useState(false);

  useEffect(() => {
    if (!accessToken) {
      dispatch(sumsubThunks.getAccessTokenTC());
    }
  }, [accessToken, dispatch]);

  const getNewAccessToken = async () => {
    try {
      const response = await SumSubAPI.getAccessToken();
      if (response?.data?.success) {
        console.log("Token request succeed");
        return response.data.token;
      } else {
        console.error("Token request did not succeed");
      }
    } catch (error) {
      console.error("Error fetching new access token:", error.message);
    }
  };
  const onMessage = (messageName, value) => {
    
    // GA4 tracking for Sumsub events
    utilityFns.ga4Tracking.trackSumsubEvent('event', messageName, value, {
      userId: profile?._id || 'unknown',
      userEmail: profile?.personal?.email || 'unknown',
      stepNumber: stepsData?.step || 'unknown'
    });

    if (messageName === "idCheck.onAgreementSigned" && value?.residency === "USA") {
      // Track US citizen blocked event
      utilityFns.ga4Tracking.trackSumsubEvent('us_citizen_blocked', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
      setUsCitizenBlocked(true);
      return;
    }
    
    if (messageName === "idCheck.onStepInitiated") {
      // Track step initiation
      utilityFns.ga4Tracking.trackSumsubEvent('step_initiated', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
      window.scrollTo(0, 0);
    }
    
    if (
      messageName === "idCheck.onApplicantStatusChanged" &&
      value.reviewResult?.reviewAnswer === "GREEN" &&
      value.reviewStatus === "completed"
    ) {
      // Track successful verification
      utilityFns.ga4Tracking.trackSumsubEvent('verification_completed', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
      
      setLocalState((localState) => ({
        ...localState,
        sumsubDocsAreVerified: true,
      }));
    }
    
    // Track other important Sumsub events
    if (messageName === "idCheck.onApproved") {
      utilityFns.ga4Tracking.trackSumsubEvent('approved', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
    }
    
    if (messageName === "idCheck.onRejected") {
      utilityFns.ga4Tracking.trackSumsubEvent('rejected', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
    }
    
    if (messageName === "idCheck.onError") {
      utilityFns.ga4Tracking.trackSumsubEvent('error', messageName, value, {
        userId: profile?._id || 'unknown',
        userEmail: profile?.personal?.email || 'unknown',
        stepNumber: stepsData?.step || 'unknown'
      });
    }
  };

  if (usCitizenBlocked) {
    return <USCitizenBlock />;
  }

  if (accessToken)
    return (
      <div className="sumsub-instance-wrapper">
        <div className="sumsub-instance-wrapper-inner">
          <h4>ID Verification</h4>
          <span className="sumsub-instance-step-number">
            step {stepsData.step} of {stepsData.totalSteps}
          </span>
        </div>
        <ContinueOnDevice />
        <SumsubWebSdk
          onMessage={onMessage}
          accessToken={accessToken}
          expirationHandler={getNewAccessToken}
        />
      </div>
    );
};

export default SumSubInstance;
